import { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const CreateDepartment = (props) => {
  const httpClient = useHttpClient(true);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
    watch,
    setValue
  } = useForm();
  const selectedCountry = watch('country', null);
  const [Open, setOpen] = useState(false);
  const [CreateModal, setCreateModal] = useState(false);
  const CreateModalToggle = () => resetForm();
  const Toggle = () => setOpen(!Open);
  const [spinner, setSpinner] = useState(false);

  const onSubmit = async (data) => {
    const DepartementData = { name: data['departement_name'], region: JSON.parse(data['region']) };
    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/departement`, DepartementData);
      if ((await response).status === 200) {
        setSpinner(false);
        props.departements();
        resetForm();
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    resetField('departement_name');
    setCreateModal(!CreateModal);
    setValue('country', ''); // Réinitialise la valeur du champ "country" à une chaîne vide
    setValue('region', '');
  };

  useEffect(() => {
    const getCountries = () => {
      httpClient.current?.get(`/api/country/all`).then((response) => {
        setCountries(response.data);
      });
    };
    getCountries();
  }, [httpClient, selectedCountry]);

  useEffect(() => {
    const getRegions = () => {
      console.log('regions');
      if (!selectedCountry) return;
      httpClient.current?.get(`/api/region/all`).then((response) => {
        let regions = response.data;
        console.log(regions);
        regions = regions.filter((region) => region.country.id === JSON.parse(selectedCountry).id);
        console.log(regions);
        console.log(selectedCountry);
        setRegions(regions);
      });
    };
    getRegions();
  }, [selectedCountry]);

  return (
    <>
      <Button outline color="success" onClick={CreateModalToggle}>
        {' '}
        {props.t('create_departement')}
      </Button>
      <Modal isOpen={CreateModal} toggle={CreateModalToggle} centered>
        <ModalHeader toggle={CreateModalToggle}>{props.t('create_departement')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={Open} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="departement_name"
                    id="departement_name"
                    aria-invalid={errors.departement_name ? 'true' : 'false'}
                    placeholder={props.t('departement_name')}
                    {...register('departement_name', { required: true })}
                  />
                  <span>{errors.departement_name && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'country_name'}>{props.t('country_name')}</label>
                  <select
                    name="country"
                    id="country"
                    className="form-control"
                    {...register('country', { required: true })}
                  >
                    <option value="">{props.t('select_country_name')}</option>
                    {countries.map((country, index) => (
                      <option id={country.id} key={index} value={JSON.stringify(country)}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                  <span>{errors.country && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'region_name'}>{props.t('region_name')}</label>
                  <select
                    name="region"
                    id="region"
                    className="form-control"
                    {...register('region', { required: true })}
                  >
                    {regions.map((region, index) => (
                      <option id={region.id} key={index} value={JSON.stringify(region)}>
                        {region.name}
                      </option>
                    ))}
                  </select>
                  <span>{errors.region && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('save')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={resetForm}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateDepartment);
